export default __webpack_public_path__ + "static/media/downloadButton.95bfd73f.png";